import { memo } from 'react';
import { IconProps } from './iconType';

export const DateIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
      <path
        d="M10.5 1.4H13.3C13.4857 1.4 13.6637 1.47375 13.795 1.60503C13.9262 1.7363 14 1.91435 14 2.1V13.3C14 13.4857 13.9262 13.6637 13.795 13.795C13.6637 13.9262 13.4857 14 13.3 14H0.7C0.514349 14 0.336301 13.9262 0.205025 13.795C0.0737497 13.6637 0 13.4857 0 13.3V2.1C0 1.91435 0.0737497 1.7363 0.205025 1.60503C0.336301 1.47375 0.514349 1.4 0.7 1.4H3.5V0H4.9V1.4H9.1V0H10.5V1.4ZM1.4 5.6V12.6H12.6V5.6H1.4ZM2.8 8.4H6.3V11.2H2.8V8.4Z"
        fill={color}
      />
    </svg>
  );
});

DateIcon.displayName = 'DateIcon';
